import './style.css';
import LogoPulsando from '../../assets/logo-pulsando.svg';

const Loader = () => {
    return (
        <div className="loader">
            <div className="loader__container">
                <img src={LogoPulsando} alt="Logo causale gestore" className="loader__logo" />
            </div>
        </div>
    );
};

export default Loader;